
/** Called from selOfi - Draw timetable div and add to reservaD for correo info */

import { reservaD, reservaT } from "./variables";
import { langDict } from "./dict";
import { setHform, dId, logger } from "./utils";
import { drawPaymentBreakdownBox, drawPresupuestoBox, showPrice } from "./result_price";
import { toggleReservaButtons } from "./result_detail";

declare var URL_BASE: string;

// Office selection change: 
function selOfi(target:string, rates: any[], json_pul: any[], json_dol: any[], sups: {}[], young: []) :void {

	logger("selOfi: " + target, "log");
	
  const pul = (<HTMLSelectElement>dId("pul"))
  const dol = (<HTMLSelectElement>dId("dol"));

  const p = pul.value;
	let ty = "dol";

  // When changing pickup office, set devolucion to match:
	if (target == "pul") {

		ty = "pul";

		for (let i = 0; i < dol.options.length; i++) {

			if (p == dol.options[i].value) {
				dol.selectedIndex = i;
				break
			}
		}

	} 

	
	if ( [1,13,17,20,30].indexOf( reservaD[21] ) >=0 && rates.length>0) {
		
    const d = dol.value;

		let rate = 0;
		let comision = 0;

		const pv = json_pul[ parseInt(p) ].idoficina;
    const dv = json_dol[ parseInt(d) ].idoficina;
		
		for (let i = 0; i < rates.length; i++) {
			if (rates[i][0] == pv && rates[i][1] == dv) {
				rate = rates[i][4];
				comision = rates[i][6];
        break;
			}
		}
		
		reservaD[26] = rate;
		reservaD[28] = comision;

	}

  // Office additional information: 
  let oficina_timetable;

	if (target == "pul") {

    const oficina_salida = json_pul[ parseInt(pul.value) ];
    oficina_timetable = oficina_salida;

		reservaD[40] = oficina_salida.idoficina;
    reservaD[42] = oficina_salida.personacontacto;
    reservaD[43] = oficina_salida.correo;
    reservaD[44] = oficina_salida.telefono;
		reservaD[45] = oficina_salida.idloc;
		reservaD[46] = oficina_salida.direccionpunto + " (<a href='https://maps.google.com/maps?z=18&t=h&q=loc:" + encodeURIComponent(oficina_salida.gps) + "'>" + langDict[22] + "</a>)";
    reservaD[47] =  oficina_salida.cuotarec;

		reservaD[75] = parseInt(oficina_salida.pagoprevio);
		reservaD[76] = parseInt(oficina_salida.pagooficina);
		reservaD[78] = parseFloat(oficina_salida.pcpagoprev);

    (<HTMLElement>dId("descripcion_horario")).innerHTML = drawHorario( oficina_salida, 53);
		
	} else {

    const oficina_devolucion = json_dol[ parseInt(dol.value) ];
    oficina_timetable = oficina_devolucion;
		
		reservaD[41] = oficina_devolucion.idoficina;
		reservaD[48] = oficina_devolucion.idloc;
		reservaD[49] = oficina_devolucion.direccionpunto + " (<a href='https://maps.google.com/maps?z=18&t=h&q=loc:" + encodeURIComponent(oficina_devolucion.gps ) + "'>" + langDict[22] + "</a>)";

		reservaD[50] = oficina_devolucion.cuotadev;

		drawHorario( oficina_devolucion, 54 );
		
	}

	showPrice();
	drawPresupuestoBox();
	drawPaymentBreakdownBox("no");

	checkTimetable(oficina_timetable, target, sups, young);
	
	if (target == "pul") {

		// Only need to check fleet on pickup office. 
		checkFlota( oficina_timetable );
		selOfi("dol", rates, json_pul, json_dol, sups, young);

	} else if (target=="dol" && reservaD[52] != "OK" ) {
		
		( <HTMLElement>dId("horario_dol") ).innerHTML = langDict[27];
		reservaD[52] = "OK";
	}
	
}



// Only draw horario (pul) into main box (not pul/dol horarios).
function drawHorario(h:any, key:number = 53) :string {
	
	// 2019-06: Save horario into variable to send to correo.
	logger("drawHorario: " + JSON.stringify(h), "log");

let lv: string = langDict[86];
let s: string = "<strong>" + langDict[31]  + "</strong>" + langDict[86];
let d: string = "<strong>" + langDict[32]  + "</strong>" + langDict[86];
let horario: string = langDict[86];
	
  // Single block horario from server: 
	if (h["horario"] !== undefined && h["horario"] != "") {
		
		reservaD[key] = h["horario"];
	
	} else if (h["hora_desdeA"] == undefined) {
		
		reservaD[key] = "Horario oficina sin confirmar";
	
	} else {
	
    // lunes-viernes
		lv = "<strong>" + langDict[30] + "</strong>" + h["hora_desdeA"].substring(0, 5) + " - " + h["hora_hastaA"].substring(0, 5);
		if (h["hora_desdeB"] != "00:00:00") {
			lv += " / " + h["hora_desdeB"].substring(0, 5) + " - " + h["hora_hastaB"].substring(0, 5)
		}
	
    // Sabado
		if (h["hora_desdeA_S"] != "00:00:00") {
			s = "<strong>" + langDict[31]  + "</strong>" + h["hora_desdeA_S"].substring(0, 5) + " - " + h["hora_hastaA_S"].substring(0, 5);
			if (h["hora_desdeB_S"] != "00:00:00") {
				s += " / " + h["hora_desdeB_S"].substring(0, 5) + " - " + h["hora_hastaB_S"].substring(0, 5)
			}
		}
		
    // Domingo
		if (h["hora_desdeA_D"] != "00:00:00") {
			d = "<strong>" + langDict[32]  + "</strong>" + h["hora_desdeA_D"].substring(0, 5) + " - " + h["hora_hastaA_D"].substring(0, 5);
			if (h["hora_desdeB_D"] != "00:00:00") {
				d += " / " + h["hora_desdeB_D"].substring(0, 5) + " - " + h["hora_hastaB_D"].substring(0, 5)
			}
		}
		
		reservaD[key] = "<span>" + lv + "</span><span>" +  s + "</span><span>" +  d + "</span>";
  
  }

  horario = `<header>
							<img src="${URL_BASE}/img/time.svg" class="icon-sml-accent" alt="">
							${langDict[23]}: ${h.nombrepunto}
						</header>
            <p>${reservaD[53]}</p>
            <div id='horario_pul'><!--horario shown above--></div>
						<div id='horario_dol'><!-- oficina closed warning --></div>`;

  return horario;

}



// Check times for "o"ficina for target (salida/dev).
// Sets OK / KO on reservaD[51/52] and updates reservaD[53/54] with error text when necessary.
function checkTimetable(o: any, target:string, sups: {}[], young: []) : boolean {
	
  let dy, tm, er, tp_check, tp_text, chkDt;
  let checkDates = [];

  // Reset office timetables if no prices for the selected configuration:
	if ( reservaD[26] == 0) {
	
		reservaD[51] = reservaD[52] = "KO";
		reservaD[53] = reservaD[54] = langDict[25];

		toggleReservaButtons(sups, young);
		return false;
		
	}
 
  
  // Desde time check:
  if (target == "pul") {
	
			dy = reservaD[9];	 // SQL from date
			tm = reservaD[2]; // SQL from time
			er = "<span class='err'>" + langDict[26] + "</span>";
			tp_check = 51;	// Horario oficina recogida OK
			tp_text = 53;	// Horario oficina recogida text
		
   // Hasta time check (keys drop-off, so no need to check if office is closed)
	} else if (target == "dol") {
			
    dy = reservaD[10];	// SQL to date
    tm = reservaD[4];	// SQL to Time
    
    er = "<p>" + langDict[27] + "</p>";
    tp_check = 52;	// Horario oficina devolucion OK
		tp_text = 54;	// Horario oficina devolucion text
  
  } else {
    return false;
  }


	
	// Dates to check against:
	// new date from iso format: 

	const dayofweek = new Date(dy).getDay();

	logger("Day of week from " + dy + ": " + dayofweek, "log");
	
	if (dayofweek == 6) {
		checkDates =[ o.hora_desdeA_S, o.hora_hastaA_S, o.hora_desdeB_S, o.hora_hastaB_S ];
	} else if (dayofweek == 0) {
		checkDates =[ o.hora_desdeA_D, o.hora_hastaA_D, o.hora_desdeB_D, o.hora_hastaB_D ];
	} else {
    checkDates =[ o.hora_desdeA, o.hora_hastaA, o.hora_desdeB, o.hora_hastaB ];
  }
	
	chkDt = Date.parse("01/01/2011 " + tm);
	
	if ( 
    (chkDt >= Date.parse("01/01/2011 " + checkDates[0]) 
    && chkDt <= Date.parse("01/01/2011 " + checkDates[1]))
  || 
    (chkDt >= Date.parse("01/01/2011 " + checkDates[2]) 
    && chkDt <= Date.parse("01/01/2011 " + checkDates[3]))
   ) {
		
	(<HTMLElement>dId("horario_" + target)).innerHTML = "";
		
	reservaD[tp_check] = "OK";
		
	} else {
		
		reservaD[tp_text] = er;
		reservaD[tp_check] = "KO";
	}

	
	setHform();
	toggleReservaButtons(sups, young);

  return true;

}



// Check selected office has vehicles available:
function checkFlota(o: any) : void {
	if (o.unidades == undefined || o.unidades <= 0) {
		reservaD[51] =  reservaD[52] = "KO";
		reservaD[53] = "<span class='err'>" + langDict[24] + "</span>";
	} 
	
}






export { drawHorario, checkTimetable, selOfi };
